import PointMarker from "public/openStack/whiteMark.png";

export const WHY_ONEMIND_CONSTANTS = [
  {
    image: PointMarker,
    title: "Deep Virtualization Expertise",
    text: "VMware, Nutanix, OpenStack certified teams",
  },
  {
    image: PointMarker,
    title: "Automation-First",
    text: "From assessment to cutover streamlining processes with efficiency",
  },
  {
    image: PointMarker,
    title: "Zero Downtime Options",
    text: "Active-active & rollback-ready migrations",
  },
  {
    image: PointMarker,
    title: "Hybrid-Friendly",
    text: "Co-exist VMware with MOST during transition",
  },
];
